import { z } from 'zod';

export const WORK_FAMILIES = ['task', 'procedure_task'] as const;
export type WorkFamily = (typeof WORK_FAMILIES)[number];
export const WorkResourceInputSchema = z.object({
  entity: z.string().trim().min(1).max(160),
  ref: z.string().trim().min(1).max(500),
  mode: z.enum(['read', 'write']).default('write'),
});
export type WorkResourceInput = z.infer<typeof WorkResourceInputSchema>;
export const WorkClaimRequestSchema = z.object({ resources: z.array(WorkResourceInputSchema).max(100).default([]) });
export const WorkClaimRefSchema = z.object({ id: z.string().uuid(), token: z.string().uuid(), fence: z.number().int().positive() });
export type WorkClaimRef = z.infer<typeof WorkClaimRefSchema>;
export const WorkClaimReleaseSchema = z.union([WorkClaimRefSchema, z.object({ force: z.literal(true) })]);

export interface WorkClaimDto {
  id: string;
  family: WorkFamily;
  task_id: string;
  state: 'active' | 'waiting' | 'released' | 'completed';
  owner: { kind: 'person' | 'system'; id: string; name: string };
  /** Disponibile solo al proprietario; cambia a ogni nuova presa in carico. */
  token: string | null;
  fence: number;
  expires_at: string;
  resources: Array<WorkResourceInput & { key: string; version: number }>;
  waiting_for: string[];
}
